import {
    type TransactionActionType,
    type TransactionInternalActionType,
    TRANSACTION_ADD_TO_QUEUE,
    TRANSACTION_FINISH,
    TRANSACTION_REMOVE_FROM_QUEUE,
    TRANSACTION_START,
} from "../actions/TransactionActions";

export type TransactionLogicStateType = {
    active: TransactionType;
    finished: TransactionType;
    cancelled: TransactionType;
};

type TransactionType = Record<string, TransactionInternalActionType>;

export const initialState: TransactionLogicStateType = {
    active: {},
    finished: {},
    cancelled: {},
};

const TransactionReducer = (state = initialState, action: TransactionActionType): TransactionLogicStateType => {
    switch (action.type) {
        case TRANSACTION_START: {
            const active = { ...state.active, [action.origAction.transaction as string]: action.transactionAction! };
            return { ...state, active };
        }

        case TRANSACTION_ADD_TO_QUEUE: {
            const { transaction, origAction } = action;

            if (state.active[transaction]) {
                const activeTransaction = { ...state.active[transaction] };
                const { type, actionId } = origAction;
                activeTransaction.actionQueue = [...activeTransaction.actionQueue, { type, actionId }];
                const active = { ...state.active, [transaction]: activeTransaction };
                return { ...state, active };
            }
            return state;
        }

        case TRANSACTION_REMOVE_FROM_QUEUE: {
            const { origAction } = action;
            const { transaction } = origAction;

            if (state.active[transaction as string]) {
                const activeTransaction = { ...state.active[transaction as string] };
                activeTransaction.actionQueue = activeTransaction.actionQueue.filter(
                    (item) => item.actionId !== origAction.actionId,
                );
                const active = { ...state.active, [transaction as string]: activeTransaction };
                return { ...state, active };
            }
            return state;
        }

        case TRANSACTION_FINISH: {
            const { transactionId } = action;
            // If no transactionId is provided, don't do anything, this is meant to execute the transactionFinish logic only.
            if (!transactionId) return state;
            const active = { ...state.active };
            const finished = { ...state.finished };

            finished[transactionId] = active[transactionId];
            delete active[transactionId];

            return { ...state, active, finished };
        }

        default:
            return state;
    }
};

export default TransactionReducer;
